
const { document } = require('window');

const $ = require('jquery');
require('bootstrap');

/*
 * Extended bootstrap modal
 * See `DEFAULTS` for comments on new options
 */

const Modal = $.fn.modal.Constructor;
const Plugin = $.fn.modal;

const ExtendedModal = function () {
	Modal.apply(this, arguments);
	this.constructor = ExtendedModal;
	return this;
};

ExtendedModal.DEFAULTS = $.extend({}, Modal.DEFAULTS, {
	// extra css classes to be added to backdrop
	backdropCss: '',
});

ExtendedModal.prototype = $.extend(Object.create(Modal.prototype), {
	backdrop: function () {
		const ret = Modal.prototype.backdrop.apply(this, arguments);
		if (this.$backdrop) {
			this.$backdrop.addClass(this.options.backdropCss);
		}
		return ret;
	},
	show: function (_relatedTarget) {
		const that = this;
		const e = $.Event('show.bs.modal', { relatedTarget: _relatedTarget });

		this.$element.trigger(e);

		if (this.isShown) {
			return $.Deferred().resolve('AlreadyShown').promise();
		}
		if (e.isDefaultPrevented()) {
			return $.Deferred().reject(new Error('Prevented')).promise();
		}

		this.isShown = true;

		this.checkScrollbar();
		this.setScrollbar();
		this.$body.addClass('modal-open');

		this.escape();
		this.resize();

		this.$element.on(
			'click.dismiss.bs.modal',
			'[data-dismiss="modal"]',
			$.proxy(this.hide, this)
		);

		this.$dialog.on('mousedown.dismiss.bs.modal', function () {
			that.$element.one('mouseup.dismiss.bs.modal', function (e) {
				if ($(e.target).is(that.$element)) {
					that.ignoreBackdropClick = true;
				}
			});
		});

		const dfr = $.Deferred();

		this.backdrop(function () {
			const transition = $.support.transition && that.$element.hasClass('fade');

			if (!that.$element.parent().length) {
				that.$element.appendTo(that.$body); // don't move modals dom position
			}

			that.$element
				.show()
				.scrollTop(0);

			that.adjustDialog();

			if (transition) {
				// eslint-disable-next-line no-unused-expressions
				that.$element[0].offsetWidth; // force reflow
			}

			that.$element.addClass('in');

			that.enforceFocus();

			const e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget });

			if (transition) {
				that.$dialog // wait for modal to slide in
					.one('bsTransitionEnd', function () {
						that.$element.trigger('focus').trigger(e);
						dfr.resolve();
					})
					.emulateTransitionEnd(Modal.TRANSITION_DURATION);
			} else {
				that.$element.trigger('focus').trigger(e);
				dfr.resolve();
			}
		});

		return dfr.promise();
	},
	hide: function (e) {
		if (e) {
			e.preventDefault();
		}

		e = $.Event('hide.bs.modal');

		this.$element.trigger(e);

		if (!this.isShown) {
			return $.Deferred().resolve('AlreadyShown').promise();
		}
		if (e.isDefaultPrevented()) {
			return $.Deferred().reject(new Error('Prevented')).promise();
		}

		this.isShown = false;

		this.escape();
		this.resize();

		$(document).off('focusin.bs.modal');

		this.$element
			.removeClass('in')
			.off('click.dismiss.bs.modal')
			.off('mouseup.dismiss.bs.modal');

		this.$dialog.off('mousedown.dismiss.bs.modal');

		if ($.support.transition && this.$element.hasClass('fade')) {
			const dfr = $.Deferred();
			const that = this;
			this.$element
				.one('bsTransitionEnd', function () {
					that.hideModal().then(dfr.resolve, dfr.reject);
				})
				.emulateTransitionEnd(Modal.TRANSITION_DURATION);
			return dfr.promise();
		}
		return this.hideModal();
		
	},
	hideModal: function () {
		const dfr = $.Deferred();
		const that = this;
		this.$element.hide();
		this.backdrop(function () {
			that.$body.removeClass('modal-open');
			that.resetAdjustments();
			that.resetScrollbar();
			that.$element.trigger('hidden.bs.modal');
			dfr.resolve();
		});
		return dfr.promise();
	},
});


function ExtendedPlugin (option, _relatedTarget) {
	return this.each(function () {
		const $this = $(this);
		let data	= $this.data('bs.modal');
		const options = $.extend(
			{},
			ExtendedModal.DEFAULTS,
			$this.data(),
			typeof option == 'object' && option
		);

		if (!data) {
			$this.data('bs.modal', (data = new ExtendedModal(this, options)));
		}
		if (typeof option == 'string') {
			data[option](_relatedTarget);
		}		else if (options.show) {
			data.show(_relatedTarget);
		}
	});
}

$.fn.modal = ExtendedPlugin;
$.fn.modal.Constructor = ExtendedModal;

$.fn.modal.noConflict = function () {
	$.fn.modal = Plugin;
	$.fn.modal.Constructor = Modal;
	return this;
};

$(document)
	.off('click.bs.modal.data-api', '[data-toggle="modal"]')
	.on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
		const $this = $(this);
		const href	= $this.attr('href');
		const $target = $(
			$this.attr('data-target')
				|| (href && href.replace(/.*(?=#[^\s]+$)/, '')) // strip for ie7
		);
		const option = $target.data('bs.modal')
				? 'toggle'
				: $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data());

		if ($this.is('a')) {
			e.preventDefault();
		}

		$target.one('show.bs.modal', function (showEvent) {
			if (showEvent.isDefaultPrevented()) {
				return;
			} // only register focus restorer if modal will actually get shown
			$target.one('hidden.bs.modal', function () {
				$this.is(':visible') && $this.trigger('focus');
			});
		});
		ExtendedPlugin.call($target, option, this);
	});

module.exports = $.fn.modal;

